export default {
  copyright: {
    en: '© 2026 OGMA Technologies. All rights reserved.',
    fr: '© 2026 OGMA Technologies. Tous droits réservés.',
  },
  our_socials: {
    en: 'Our socials',
    fr: 'Nos réseaux sociaux',
  },
  location: {
    en: '1100 Notre-Dame street, Montréal, QC H3C 1K3',
    fr: '1100 rue Notre-Dame, Montréal, QC H3C 1K3',
  },
  room_number: {
    en: 'Room D-2027',
    fr: 'Local D-2027',
  },
};
